export * from './ActorRdfMetadataAccumulateCardinality';
